import { TableRowCell } from '@dtk/ui-components';

export const TableRowCellBlok = ({ ...props }) => {
  return <TableRowCell data={props} />;
};
